import React, { useEffect, useState } from "react";

export default function ColorModeToggle() {
  const [mode, setMode] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("color-mode") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    }
    return "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem("color-mode", mode);
    // Force repaint — needed on pages without backdrop-filter (which other pages
    // get for free via the sticky header), otherwise background-attachment:fixed
    // stays on a stale GPU layer until a resize triggers re-composition.
    void document.body.offsetHeight;
  }, [mode]);

  const toggleMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <button
      className="color-mode-toggle"
      aria-label={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggleMode}
      style={{
        marginLeft: 16,
        padding: "6px 16px",
        borderRadius: 20,
        border: "1px solid var(--sep-strong)",
        background: "var(--bg-elevated)",
        color: "var(--text)",
        fontWeight: 600,
        fontSize: "1.1rem",
        cursor: "pointer",
        transition: "background 0.2s, color 0.2s",
      }}
    >
      {mode === "dark" ? "🌙 Dark" : "☀️ Light"}
    </button>
  );
}
